import { CoreInputView, CoreTextView, CoreLayoutView, ORIENTATION_ENUM } from '@core/widgets';
import React, { useId } from 'react';
import { TextStyle } from '../../../types/styles';
import styles from '../Calculator.module.css';
import { getClearValue, getFormattedValue } from '../utils/format/format';
import { THandleUpdateValue } from '../utils/types';

type TCalculatorInputProps = {
    label?: string;
    name: string;
    value: string;
    isError?: boolean;
    isFrom?: boolean;
    handleUpdateValue: THandleUpdateValue;
    fontSize: string;
    subRow: React.ReactNode;
    tabIndex?: number;
    parentStyleNames?: string[];
};

const CalculatorInput = React.memo(
    ({ label, isError, value, handleUpdateValue, tabIndex, subRow, name, isFrom, fontSize, parentStyleNames }: TCalculatorInputProps) => {
        const inputId = useId();

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const clearValue = getClearValue(e?.target.value, value);
            handleUpdateValue(clearValue, e.target.name, isFrom);
        };
        return (
            <CoreLayoutView
                styleName="calculatorInputColumn"
                parentStyleNames={parentStyleNames}
                styleProps={{ orientation: ORIENTATION_ENUM.VERTICAL, lineX: 'center' }}
            >
                <CoreTextView
                    text={label}
                    styleName="calculatorInputTitle"
                    parentStyleNames={parentStyleNames}
                    styleProps={{
                        ...TextStyle.secondary,
                        main: 'var(--color-grey_72_lc)',
                        margin: { bottom: 4 },
                    }}
                />
                <div className={styles.calculatorInputWrapper}>
                    <CoreInputView
                        styleName="calculatorInputAmount"
                        parentStyleNames={parentStyleNames}
                        styleProps={{
                            font: 'var(--font-display1)',
                            outline: 'transparent',
                            padding: { top: 0, right: 0, bottom: 0, left: 0 },
                            textAlign: 'center',
                            height: 48,
                            error: 'var(--color-pink_100)',
                            fontStyle: { fontSize: parseInt(fontSize) || 40, fontSizeXl: 48, lineHeightXl: 64 },
                            hovered: {
                                onSurface: 'var(--color-purple_100)',
                            },
                        }}
                        dataTest={`calculator_input_${isFrom ?? ''}`}
                        id={inputId}
                        name={name}
                        value={getFormattedValue(value)}
                        autoComplete="off"
                        onChange={handleChange}
                        type="text"
                        inputMode="decimal"
                        tabIndex={tabIndex}
                        isError={isError}
                    />
                </div>
                {subRow}
            </CoreLayoutView>
        );
    },
);
export { CalculatorInput };
